import { render, staticRenderFns } from "./ViqGapResults.vue?vue&type=template&id=33798882&scoped=true"
import script from "./ViqGapResults.vue?vue&type=script&lang=js"
export * from "./ViqGapResults.vue?vue&type=script&lang=js"
import style0 from "./ViqGapResults.vue?vue&type=style&index=0&id=33798882&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33798882",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33798882')) {
      api.createRecord('33798882', component.options)
    } else {
      api.reload('33798882', component.options)
    }
    module.hot.accept("./ViqGapResults.vue?vue&type=template&id=33798882&scoped=true", function () {
      api.rerender('33798882', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/viq/ViqGapResults.vue"
export default component.exports